import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SigninComponent } from 'src/app/layouts/public-layout/pages/signin/signin.component';
import { ForgotPasswordComponent } from 'src/app/layouts/public-layout/pages/forgot-password/forgot-password.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';

const PublicRoutes: Routes = [
  {
    path: '',
    redirectTo: 'signin',
    pathMatch: 'full'
  },
  {
    path: 'signin',
    component: SigninComponent
  },
  {
    path: 'forget-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  }
];
@NgModule({
  declarations: [SigninComponent, ForgotPasswordComponent, ResetPasswordComponent],
  imports: [CommonModule, SharedModule, RouterModule.forChild(PublicRoutes)]
})
export class PublicLayoutModule {}
